import { AnimatePresence, motion } from "motion/react";
import { PropsWithChildren } from "react";
import usePreventBodyScroll from "../hooks/usePreventBodyScroll";
import styles from "./BottomSheet.module.css";

type Props = PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
}>;

const BottomSheet = ({ isOpen, onClose, children }: Props) => {
  usePreventBodyScroll(isOpen);

  return (
    <AnimatePresence>
      {isOpen && (
        <div className={styles.wrapper}>
          <motion.div
            className={styles.overlay}
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />
          <motion.div
            className={styles.bottomSheet}
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
            drag="y"
            dragConstraints={{ top: 0, bottom: 100 }}
            onDragEnd={(_event, info) => {
              if (info.point.y > window.innerHeight * 0.75) {
                onClose();
              }
            }}
          >
            <div className={styles.grabHandle} />
            {children}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default BottomSheet;
